export default __webpack_public_path__ + "static/media/nodata.381104c4.svg";